import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../common/breadcrumbs";
import * as doctorSpecializationServices from "../../services/coach-specialization.services";
import { SWAL_SETTINGS, INPUT_LENGTH_500, INPUT_LENGTH_100 } from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

const AddCoachSpecialization = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation()
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [initialValues, setInitialValues] = useState({
    title: "",
  });

  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("Coach Specialization"), url: "/admin/coach-specialization/list/1" },
    { title: t("admin.faq.link_add"), url: "" },
  ];

  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state?.title : "",

    });
    setDataLoaded(true);
  }, []);

  return (
      <>
          <Breadcrums data={breadcrumbs} />
          {dataLoaded ? (
              <Formik
                  initialValues={initialValues}
                  validateOnBlur={false}
                  validate={(values) => {
                      const error = {};

                      if (!values.title || !values.title.trim()) {
                          error.title = "admin.faq.label_title_error";
                      } else if (values.title.length > INPUT_LENGTH_100) {
                          error.title = "You have reached maximum length of 100 characters";
                      } else if (!/[a-zA-Z0-9]/.test(values.title)) {
                          error.title = "Title cannot contain only special characters";
                      } else if (/\s{2,}/.test(values.title)) {
                          error.title = "Title should not contain multiple consecutive spaces";
                      }

                      return error;
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                      setSubmitted(true);
                      globalLoader(true);
                      console.log(values);
                      let formData = new FormData();
                      formData.append("title", values.title);
                      doctorSpecializationServices
                          .Add(formData)
                          .then((response) => {
                              setSubmitting(false);
                              if (response.success) {
                                  Swal.fire({
                                      icon: "success",
                                      text: response.message,
                                      ...SWAL_SETTINGS,
                                  });
                                  setTimeout(() => {
                                      resetForm({ values: "" });
                                      globalLoader(false);
                                      navigate(`/admin/coach-specialization/list/1`);
                                  }, 1000);
                              } else {
                                  Swal.fire({
                                      icon: "error",
                                      text: handleServerValidations(response),
                                      ...SWAL_SETTINGS,
                                  });
                                  setSubmitted(false);
                                  globalLoader(false);
                              }
                          })
                          .catch((error) => {
                              console.log("error ====> ", error);
                          });
                  }}
              >
                  {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
                      <form onSubmit={handleSubmit}>
                          <div className="row row-sm">
                              <div className="col-lg-12 col-md-12 animation_fade">
                                  <div className="card custom-card">
                                      <div className="card-body">
                                          <div>
                                              <h6 className="main-content-label mb-3">{t("Add Coach Specialization")}</h6>
                                          </div>
                                          <div className="row row-sm">
                                              <div className="col-lg-6 text-center form-group">
                                                  <label htmlFor="title" className="text-left d-flex">
                                                      {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                  </label>
                                                  <input
                                                      name="title"
                                                      id="title"
                                                      type="text"
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      value={values.title}
                                                      className="form-control"
                                                      placeholder={t("Enter coach specialization")}
                                                  />
                                                  <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                                              </div>
                                              <div className="">
                                                  <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                                                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                      {t("admin.button.btn_submit")}
                                                  </button>
                                                  <button className="btn ripple btn-secondary" type="button" disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                                                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                      {t("admin.button.btn_cancel")}
                                                  </button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </form>
                  )}
              </Formik>
          ) : (
              <></>
          )}
      </>
  );
};

export default AddCoachSpecialization;
